import { supabase } from './client';

// --- Admin: Reset Current Set ---

export async function resetCurrentSet(params: {
  matchId: string;
  adminId?: string;
  reason?: string;
}): Promise<{ success: boolean; setId: string; matchId: string; setNumber: number }> {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  // NEW-C01 fix: use the admin's session JWT, not the anon key.
  // The edge function now validates the JWT and enforces role = 'admin'.
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  const res = await fetch(`${supabaseUrl}/functions/v1/reset-current-set`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${session.access_token}`,
      'Apikey': anonKey,
    },
    body: JSON.stringify(params),
  });

  const data = await res.json().catch(() => ({ error: 'Invalid response' }));

  if (!res.ok) {
    throw new Error(data.error || `Reset failed (${res.status})`);
  }

  return data;
}

// --- Admin: Audit Logs ---

export async function getAuditLogs(matchId?: string, limit = 50) {
  let query = supabase
    .from('admin_audit_logs')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(limit);

  if (matchId) {
    query = query.eq('match_id', matchId);
  }

  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}
